import { createAction, props } from '@ngrx/store';

/******************* Check User Membership Status In AppSumo  ***********************/
export const checkUserMembershipStatusInAppSumo = createAction('[AppSumo] Check User Membership Status In AppSumo');

export const checkUserMembershipStatusInAppSumoSuccess = createAction('[AppSumo]  Check User Membership Status In AppSumo Success', props<{ response: boolean }>());

export const checkUserMembershipStatusInAppSumoFailure = createAction('[AppSumo]  Check User Membership Status In AppSumo Failure', props<{ error: any }>());